import React from 'react';

const {
  locale: { country },
} = window.inlineGlobalConfig;

export const ExchangeHeader = ({ orderNumber }) => {
  return (
    <div className="exchange-header">
      <h1>SELECT ITEMS TO EXCHANGE</h1>
      <div className="order-number">ORDER: {orderNumber}</div>
      {country === 'us' && (
        <div className="order-tax-details">
          Refund amounts are shown excluding taxes. Taxes will be included in the return and replacement item amounts.
        </div>
      )}
    </div>
  );
};
